interface Props {
  amount: number;
  currency: string;
}

export const currencyFormatter = (props: Props) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: props.currency
  });

  return formatter.format(props.amount);
};

export const formattedNumber = (value: number, min = 0, max = 2) => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: min,
    maximumFractionDigits: max
  }).format(value);
};
